import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  ["#experiencias", "Experiencias"],
  ["#reservar", "Reservar"],
  ["#galeria", "Galería"],
  ["#instalaciones", "Instalaciones"],
  ["#ubicacion", "Ubicación"],
  ["#preguntas", "Preguntas"],
];

export function Header({ title }) {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setSolid(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  const light = !solid && !open;
  return (
    <header data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-40 transition-colors duration-300 ${light ? "bg-transparent" : "bg-[#FAF7F2]/85 backdrop-blur-xl border-b border-border"}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
        <a href="#inicio" data-testid="header-logo" className={`font-serif text-2xl tracking-tight ${light ? "text-white" : "text-foreground"}`}>
          {title || "Rachel Lodge"}
        </a>
        <nav className="hidden lg:flex items-center gap-8">
          {LINKS.map(([h, l]) => (
            <a key={h} href={h} data-testid={`nav-${h.slice(1)}`}
              className={`text-sm font-medium transition-opacity hover:opacity-70 ${light ? "text-white" : "text-foreground"}`}>{l}</a>
          ))}
          <a href="#reservar" data-testid="header-book-btn"
            className="rounded-full bg-[#C86D51] text-white px-5 py-2.5 text-sm font-semibold transition-colors hover:bg-[#B25C42]">
            Reservar ahora
          </a>
        </nav>
        <button className={`lg:hidden ${light ? "text-white" : "text-foreground"}`} onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle" aria-label="Menú">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <nav className="lg:hidden bg-[#FAF7F2] border-t border-border px-6 py-4 flex flex-col gap-4" data-testid="mobile-menu">
          {LINKS.map(([h, l]) => (
            <a key={h} href={h} onClick={() => setOpen(false)} className="text-base font-medium">{l}</a>
          ))}
        </nav>
      )}
    </header>
  );
}
